import React, { useEffect, useState } from "react";
import LOGO from "../Assets/delhiBackground.png";
import { useSelector, useDispatch } from "react-redux";
import land from "../Assets/land.png";
import basket from "../Assets/basketball-player.png";
import law from "../Assets/law.png";
import search from "../Assets/search.png";
import sky from "../Assets/skyscraper.png";
import vegan from "../Assets/vegan.png";
import list from "../Assets/list.png";
import Table from "react-bootstrap/Table";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import SideNavbar from "./SideNavBar";
import SideBar from "./SideBar";
import { citizenDashboardDetails } from "../Services/getServices";
import { citizenSchemeDetails } from "../Services/getServices";
import { loader } from "../redux/type";
import Accordion from "react-bootstrap/Accordion";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { AesUtil } from "../Services/encryptionDecryption";

const CitizenDashboard = () => {
  const dispatch = useDispatch();
  const [deptList, setDeptList] = useState([]);
  const userData = JSON.parse(localStorage.getItem("user"));
  // console.log("DATATATA=", userData?.user?.mobile);
  const [bhoomiDetails, setBhoomiDetails] = useState([]);
  const [citizenCentricDetails, setCitizenCentricDetails] = useState([]);
  const [waterBill, setWaterBill] = useState([]);
  const aes = new AesUtil();

  const name = userData?.user?.firstName;
  const mobileNum =userData?.user?.mobile;
  // console.log("MOBLIE NO=",mobileNum)

  const mob44=`'${mobileNum}'`;
  console.log("DATATATA=", `'${mobileNum}'`);
  // console.log("ABCD=",aes.decrypt("AO8jByoorM4BcwzObvhRHpzLDmOGlDgqVU+9aFtchoURl1uoUC3rirGrWLkn29Coyv79mgTTOETwiA+oLz0mh3nT3M1hMOVC+wzZA7Y8ACSncJMdbtIXrlYDdDmcb2Cwg2YcpaO1ykpfPasYqkQqMUa2zFPLXiYFnzs8RABCxCv2Fuc72P5NxAdSk93QvxleHXQuFtJmDOMm6lgJm9eeBXgHMBJ+h+xExgjQJTsyg6PJduodmrX2w11w29qV3Lsb"));
  // const mobileNum =aes.decrypt(mob44);
  // console.log("DATATATA2=", aes.decrypt(mob44));

    // console.log("DATATATA2=", aes.decrypt('/COxbuMbEf9OBKpPbKkCQDx10j+gdIf6O06z0bMx1IDHNlRB7IB9GZ1gwuDgn8d+'));
    // console.log("DATATATA26=", aes.decrypt('U2FsdGVkX1+JUCo4JSFQvKejP0Vsv770yIKD1KXrGco='));
    // console.log("DATATATA23=", aes.encrypt('123123'));


  

  useEffect(() => {
    dashboardDetails();
    schemeDetails();
  }, []);

  function schemeDetails() {
    let mob = 9811090749;
    // let mob = mobileNum;
    // console.log("DATATATA=", aes.decrypt(`'${JSON.stringify(mobileNum)}'`));
    

    dispatch({ type: loader.startLoader });

    citizenSchemeDetails(mob, (res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.data?.status) {
        // console("FIRST")
        // console.log("SCHEME=", res?.data?.result?.bhoomiDashboardDetails);

        setBhoomiDetails(res?.data?.result?.bhoomiDashboardDetails);
        setCitizenCentricDetails(
          res?.data?.result?.citizenCentricDashboardDetails
        );
        setWaterBill(res?.data?.result?.waterBillsDetails);
      } else {
        console.log(res);
      }
    });
  }

  function dashboardDetails() {
    dispatch({ type: loader.startLoader });

    citizenDashboardDetails((res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.data?.status) {
        // console.log(res);
        setDeptList(res?.data?.result?.deptApplicationList);
      } else {
        // console.log(res);
      }
    });
  }
  var [arr, setArr] = useState([]);
  const [appDetails, setAppDetails] = useState("0");
  const [deptHeader, setDeptHeader] = useState("");
  function applicationInfo(ind) {
    setAppDetails("2");
    // console.log("INDEX=", ind);
    setDeptHeader(deptList[ind]?.departmentName);
    // console.log("DATA=", deptList[ind]?.application);

    setArr(deptList[ind]?.application);
  }

  return (
    <>
      {/* <SideBar /> */}

      <div className="card shadow myprofileCard ">
        <div className="card-body overFlow p-md-3">
          <h4>Welcome {name}, To eSevadawar Portal</h4>
          <br></br>

          <h5 className="h2_heading">Dashboard</h5>

          <Tabs
            defaultActiveKey="bhoomi"
            id="justify-tab-example"
            className="mb-3"
            justify
          >
            <Tab eventKey="bhoomi" title="Bhoomi">
              <div className="card-body ">
                {bhoomiDetails?.length === 0 ? (
                  <>
                    <p>
                      <b>No Record Found For Bhoomi</b>
                    </p>
                  </>
                ) : (
                  <>
                    <div>
                      <div className="card shadow  ">
                        <div className="card-body">
                          <div
                            className="card-title bg-primary "
                            style={{
                              textAlign: "center",
                              height: "2rem",
                              color: "white",
                            }}
                          >
                            {" "}
                            Personal Detaiils
                          </div>
                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Mobile Number</th>
                                <th>Aadhaar Number</th>
                                <th>Pan Number</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{bhoomiDetails[0]?.fullName}</td>
                                <td>{bhoomiDetails[0]?.email}</td>
                                <td>{bhoomiDetails[0]?.mobileNumber}</td>

                                <td>{bhoomiDetails[0]?.aadharNumber}</td>
                                <td>{bhoomiDetails[0]?.panNumber}</td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </div>

                      <div className="card shadow mt-2 ">
                        <div className="card-body">
                          <div
                            className="card-title bg-primary "
                            style={{
                              textAlign: "center",
                              height: "2rem",
                              color: "white",
                            }}
                          >
                            {" "}
                            Scheme Detaiils
                          </div>
                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>Scheme Name</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{bhoomiDetails[0]?.schemeName}</td>
                              </tr>
                            </tbody>
                          </Table>

                          {/* <p>
                      {" "}
                      <b>Scheme Name:</b>
                      {bhoomiDetails[0]?.schemeName}{" "}
                    </p> */}
                        </div>
                      </div>
                      <div className="card shadow mt-2">
                        <div className="card-body">
                          <div
                            className="card-title bg-primary "
                            style={{
                              textAlign: "center",
                              height: "2rem",
                              color: "white",
                            }}
                          >
                            {" "}
                            Payment Detaiils
                          </div>

                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>Amount</th>
                                <th>Bid Amount</th>
                                <th>Payment Date</th>
                                {/* <th>Aadhaar Number</th>
                <th>Pan Number</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{bhoomiDetails[0]?.amount}</td>
                                <td>{bhoomiDetails[0]?.bidAmount}</td>
                                <td>{bhoomiDetails[0]?.paymentDate}</td>

                                {/* <td>{bhoomiDetails[0]?.aadharNumber}</td>
                <td>{bhoomiDetails[0]?.panNumber}</td> */}
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </div>

                      <div className="card shadow  mt-2 ">
                        <div className="card-body">
                          <div
                            className="card-title bg-primary "
                            style={{
                              textAlign: "center",
                              height: "2rem",
                              color: "white",
                            }}
                          >
                            Sales Detaiils
                          </div>

                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>Sales Detail ID</th>
                                <th>Plot Id</th>
                                <th>sale Date</th>
                                <th>sale Modification Date</th>
                                {/* <th>Pan Number</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{bhoomiDetails[0]?.salesDetailId}</td>
                                <td>{bhoomiDetails[0]?.plotId}</td>
                                <td>{bhoomiDetails[0]?.saleDate}</td>

                                <td>
                                  {bhoomiDetails[0]?.saleModificationDate}
                                </td>
                                {/* <td>{bhoomiDetails[0]?.panNumber}</td> */}
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </div>
                      <div className="card shadow  mt-2 ">
                        <div className="card-body">
                          <div
                            className="card-title bg-primary "
                            style={{
                              textAlign: "center",
                              height: "2rem",
                              color: "white",
                            }}
                          >
                            Status Detaiils
                          </div>

                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>Status Id</th>
                                <th>Status Name</th>
                                <th>Possession Issue Date</th>
                                <th>Possession Slip Generated Date</th>
                                <th>Possession Slip Generated By</th>
                                <th>HandoverDate</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{bhoomiDetails[0]?.statusId}</td>
                                <td>{bhoomiDetails[0]?.statusName}</td>
                                <td>{bhoomiDetails[0]?.possessionIssueDate}</td>

                                <td>
                                  {
                                    bhoomiDetails[0]
                                      ?.possessionSlipGeneratedDate
                                  }
                                </td>
                                <td>
                                  {bhoomiDetails[0]?.possessionSlipGeneratedBy}
                                </td>
                                <td>{bhoomiDetails[0]?.handoverDate}</td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </Tab>
            <Tab eventKey="citizen" title="Citizens Centric">
              {citizenCentricDetails?.length === 0 ? (
                <>
                  <p>
                    <b>No Record Found For Citizen Centric</b>
                  </p>
                </>
              ) : (
                <>
                  <div className="card-body ">
                    <div className="card shadow  ">
                      <div className="card-body">
                        <div
                          className="card-title bg-primary "
                          style={{
                            textAlign: "center",
                            height: "2rem",
                            color: "white",
                          }}
                        >
                          {" "}
                          Personal Detaiils
                        </div>
                        <Table striped bordered hover>
                          <thead>
                            <tr>
                              <th> Applicant Name</th>
                              <th>File No.</th>
                              <th>Application No. </th>
                              <th>Department Name</th>
                              <th>Actioner</th>
                            </tr>
                          </thead>
                          <tbody>
                            {citizenCentricDetails?.map((val, index) => (
                              <tr key={index}>
                                <td>
                                  {citizenCentricDetails[index]?.firstName +
                                    " " +
                                    citizenCentricDetails[0]?.lastName}{" "}
                                </td>
                                <td>{citizenCentricDetails[index]?.fileNo}</td>
                                <td>
                                  {citizenCentricDetails[index]?.applicationNo}
                                </td>
                                <td>
                                  {citizenCentricDetails[index]?.adIdDeptName}
                                </td>
                                <td>
                                  {citizenCentricDetails[index]?.actioner}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </Tab>
            <Tab eventKey="water" title="Water Bill">

              {waterBill?.length===0?<><p><b>No Record Found For Water Bill</b></p></>:<>
                <div className="card-body ">
                <div className="card shadow  ">
                  <div className="card-body">
                    <div
                      className="card-title bg-primary "
                      style={{
                        textAlign: "center",
                        height: "2rem",
                        color: "white",
                      }}
                    >
                      {" "}
                      Bill Detaiils
                    </div>
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>Consumer Id</th>
                          <th>Bill No.</th>
                          <th>Bill Date </th>
                          <th>Due Date</th>
                          <th>Amount Pay</th>
                          <th>Amount Pay After Due Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {waterBill?.map((val, index) => (
                          <tr key={index}>
                            <td>{waterBill[index]?.consumerId} </td>
                            <td>{waterBill[index]?.billNo} </td>
                            <td>{waterBill[index]?.billDate} </td>
                            <td>{waterBill[index]?.payByDate} </td>
                            <td>{waterBill[index]?.amtPay} </td>
                            <td>{waterBill[index]?.amtPayAfterDueDate} </td>
                          </tr>
                        ))}
                        {/* <tr>
                          <td>{waterBill[0]?.consumerId  } </td>
                          <td>{waterBill[0]?.billNo  } </td>
                          <td>{waterBill[0]?.billDate  } </td>
                          <td>{waterBill[0]?.payByDate  } </td>
                          <td>{waterBill[0]?.amtPay  } </td>
                          <td>{waterBill[0]?.amtPayAfterDueDate  } </td>
                          
                        </tr> */}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
              </>}
              
            </Tab>
          </Tabs>

          {/* <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Bhoomi</Accordion.Header>
              <Accordion.Body>
              
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>Citizens Centric</Accordion.Header>
              <Accordion.Body>
              
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>Water Bill</Accordion.Header>
              <Accordion.Body>
                
              </Accordion.Body>
            </Accordion.Item>
          </Accordion> */}

          {/* <div>
            <div className="card shadow">
              <div className="card-body ">
                <div
                  className="card-title bg-primary "
                  style={{
                    textAlign: "center",
                    height: "3rem",
                    color: "white",
                  }}
                >
                  <h4>Bhoomi</h4>
                </div>
                <div className="card shadow  ">
                  <div className="card-body">
                    <div
                      className="card-title bg-primary "
                      style={{
                        textAlign: "center",
                        height: "2rem",
                        color: "white",
                      }}
                    >
                      {" "}
                      Personal Detaiils
                    </div>
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Mobile Number</th>
                          <th>Aadhaar Number</th>
                          <th>Pan Number</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{bhoomiDetails[0]?.fullName}</td>
                          <td>{bhoomiDetails[0]?.email}</td>
                          <td>{bhoomiDetails[0]?.mobileNumber}</td>

                          <td>{bhoomiDetails[0]?.aadharNumber}</td>
                          <td>{bhoomiDetails[0]?.panNumber}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>

                <div className="card shadow mt-2 ">
                  <div className="card-body">
                    <div
                      className="card-title bg-primary "
                      style={{
                        textAlign: "center",
                        height: "2rem",
                        color: "white",
                      }}
                    >
                      {" "}
                      Scheme Detaiils
                    </div>
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>Scheme Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{bhoomiDetails[0]?.schemeName}</td>
                        </tr>
                      </tbody>
                    </Table>

                  </div>
                </div>
                <div className="card shadow mt-2">
                  <div className="card-body">
                    <div
                      className="card-title bg-primary "
                      style={{
                        textAlign: "center",
                        height: "2rem",
                        color: "white",
                      }}
                    >
                      {" "}
                      Payment Detaiils
                    </div>

                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>Amount</th>
                          <th>Bid Amount</th>
                          <th>Payment Date</th>
                     
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{bhoomiDetails[0]?.amount}</td>
                          <td>{bhoomiDetails[0]?.bidAmount}</td>
                          <td>{bhoomiDetails[0]?.paymentDate}</td>

                       
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>

                <div className="card shadow  mt-2 ">
                  <div className="card-body">
                    <div
                      className="card-title bg-primary "
                      style={{
                        textAlign: "center",
                        height: "2rem",
                        color: "white",
                      }}
                    >
                      Sales Detaiils
                    </div>

                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>Sales Detail ID</th>
                          <th>Plot Id</th>
                          <th>sale Date</th>
                          <th>sale Modification Date</th>
                 
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{bhoomiDetails[0]?.salesDetailId}</td>
                          <td>{bhoomiDetails[0]?.plotId}</td>
                          <td>{bhoomiDetails[0]?.saleDate}</td>

                          <td>{bhoomiDetails[0]?.saleModificationDate}</td>
                   
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
                <div className="card shadow  mt-2 ">
                  <div className="card-body">
                    <div
                      className="card-title bg-primary "
                      style={{
                        textAlign: "center",
                        height: "2rem",
                        color: "white",
                      }}
                    >
                      Status Detaiils
                    </div>

                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>Status Id</th>
                          <th>Status Name</th>
                          <th>Possession Issue Date</th>
                          <th>Possession Slip Generated Date</th>
                          <th>Possession Slip Generated By</th>
                          <th>HandoverDate</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{bhoomiDetails[0]?.statusId}</td>
                          <td>{bhoomiDetails[0]?.statusName}</td>
                          <td>{bhoomiDetails[0]?.possessionIssueDate}</td>

                          <td>
                            {bhoomiDetails[0]?.possessionSlipGeneratedDate}
                          </td>
                          <td>{bhoomiDetails[0]?.possessionSlipGeneratedBy}</td>
                          <td>{bhoomiDetails[0]?.handoverDate}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default CitizenDashboard;
